/**
 * @author jenniferfengFeng
 * Date: 20/07/31
 */
import Button from './index.vue';

Button.install = function (Vue) {
  Vue.component(Button.name, Button);
};

export default Button;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/button/index.js
// module id = null
// module chunks = 